import React from 'react'
import { CheckBox, ErrorWrapper, Input, Label, Rules, RulesContainer, TabChanger } from '../../../styles/newStyles/Register.styled'
import Text from '../../../core/utils/Text'
import { AnimatePresence } from 'framer-motion'
import { GoCheck } from 'react-icons/go'
import { HOME } from '../../../core/constants/urls'
import { TABLET_SIZE } from '../../../core/constants/common'
import { useWindowSize } from '../../../core/hooks/useWindowSize'
import { useMainContext } from '../../../core/contexts/main'
import SetPasswordForm from '../components/SetPasswordForm'

const SignupPage = ({ onInputValueChange,
    onCheckBoxClicked,
    inputValues,
    goToRules,
    validationStatus,
    password,
    setPassword

}) => {
    const { main: { lang } } = useMainContext()
    const { width } = useWindowSize()

    return (
        <>
            <div className='flex flex-col gap-2'>
                <Label htmlFor='email-phone'>
                    <Text tid={'enter-phone-email'} />
                </Label>
                <Input
                    type='text'
                    placeholder='شماره موبایل یا ایمیل'
                    onChange={(e) => onInputValueChange(e, 'main')}
                    value={inputValues.mobileOrEmail}
                    autoFocus={true}
                    status={validationStatus}
                    id='email-phone'
                />
                {/* <SetPasswordForm
                    password={password}
                    onPasswordChange={setPassword}
                /> */}
                {validationStatus === 'error' && (
                    <ErrorWrapper>
                        <Text tid='format-wrong' className='text-sm' />
                    </ErrorWrapper>
                )}
                <Label htmlFor='referral-code'>
                    <Text tid={'referral-code-label'} />
                </Label>
                <Input
                    id='referral-code'
                    type='text'
                    placeholder='کد دعوت (اختیاری)'
                    onChange={(e) => onInputValueChange(e, 'option')}
                />
            </div>
            <AnimatePresence exitBeforeEnter>
                <>
                    <RulesContainer>
                        <CheckBox onClick={onCheckBoxClicked}>
                            {inputValues.rulesAccepted && (
                                <GoCheck size={width < TABLET_SIZE ? 16 : 20} color='#272727' />
                            )}
                        </CheckBox>
                        {lang === 'en' ? (
                            <>
                                I accept <Rules>Rules and Regulations</Rules>
                            </>
                        ) : (
                            <Label className='text-[0.7rem] sm:text-[0.9rem]'>
                                من تمام{' '}
                                <Rules onClick={goToRules}>
                                    <span className='!text-mainHightContrast dark:!text-main'>
                                        قوانین و مقررات
                                    </span>
                                </Rules>{' '}
                                سایت دکسکو را میپذیرم.
                            </Label>
                        )}
                    </RulesContainer>
                </>
            </AnimatePresence>
            <TabChanger className={'gap-2'}>
                <Text tid={'have-account'} />
                <Rules
                    onClick={() => {
                        window.location.assign('/user/auth/signin')
                    }}
                    fontSize='1rem'
                >
                    <Text
                        className='text-main hover:opacity-80'
                        tid={'signin'}
                    />
                </Rules>
            </TabChanger>
        </>
    )
}

export default SignupPage